/** Steps項目 */
export const A230_STEPS_ITEMS = [
  { label: '新規リクエスト登録入力' },
  { label: '登録内容確認' },
  { label: '登録完了' },
];